import React from "react"
import PropTypes from "prop-types"
import MomentPropTypes from "react-moment-proptypes"
import { Button } from "reactstrap"
import { subjectsPropTypes } from "../../utils/propTypes"
import EditCaseModal from "../EditCaseModal"
import "./EmployeeCaseSummary.scss"

const EmployeeCaseSummary = (props) => {
  const dateFormat = "M/D/YYYY • h:mma"
  const isArchived = props.archivedAt !== null

  return (
    <div className={`EmployeeCaseSummary ${props.loading ? "loading" : ""}`}>
      <div className="employee-information">
        <div className="name">
          <div>{props.name}</div>
        </div>
        <div className="time-range">
          <div>{props.startAt?.format(dateFormat)}</div>
          <div>{props.endAt?.format(dateFormat)}</div>
        </div>
        <div className="controls">
          {props.id && (
            <EditCaseModal
              id={props.id}
              internalId={props.caseId}
              subjects={props.subjects}
              caseType={"employeePositive"}
            />
          )}
          {props.visitModal && React.createElement(props.visitModal)}
        </div>
      </div>
      <div className="buttons">
        <Button
          color="primary"
          className="archive-button"
          onClick={() =>
            props.onArchive({
              id: props.id,
              archive: !isArchived,
              type: "employeePositive",
              facilityId: props.facilityId,
              subjects: props.subjects.map((subject) => ({
                entityId: subject.entityId,
                startAt: subject.startAt.format(),
                endAt: subject.endAt.format(),
              })),
            })
          }
        >
          {isArchived ? "Re-Open" : "Archive"}
        </Button>
      </div>
    </div>
  )
}

EmployeeCaseSummary.propTypes = {
  archivedAt: PropTypes.string,
  caseId: PropTypes.string.isRequired,
  facilityId: PropTypes.string,
  loading: PropTypes.bool,
  name: PropTypes.string,
  startAt: MomentPropTypes.momentObj,
  endAt: MomentPropTypes.momentObj,
  onArchive: PropTypes.func,
  onEdit: PropTypes.func,
  subjects: subjectsPropTypes,
  id: PropTypes.string,
  visitModal: PropTypes.func,
}

EmployeeCaseSummary.defaultProps = {
  subjects: [],
}

export default EmployeeCaseSummary
